import React from 'react'
import { Link } from 'react-router'
import * as MabnaButton from '../Button/Button'

import KeyValueTable from '../DataPresenters/keyValueTable'
import GridedRow from '../GridedRow/GridedRow'

const profileLink = userType => id => {
  return <MabnaButton.Primary
    href={`/dashboard/manager-${userType}s/view/${id}`}
    target='_blank'
  >
    پروفایل
  </MabnaButton.Primary>
}

const ViewSupportTicketUser = ({user}) => {
  const propertiesToShow = [
    [
      { key: 'username', title: 'نام کاربری' },
    ],
    [
      { key: 'first_name', title: 'نام' },
    ],
    [
      { key: 'last_name', title: 'نام خانوادگی' },
    ],
    [
      { key: 'id', title: 'پروفایل', renderer: profileLink(user.extra.role) },
    ],
  ]

  return (
    <div className='user-info'>
      <GridedRow columns={4}>
        <KeyValueTable data={user} propertiesToShow={propertiesToShow[0]} />
        <KeyValueTable data={user} propertiesToShow={propertiesToShow[1]} />
        <KeyValueTable data={user} propertiesToShow={propertiesToShow[2]} />
        <KeyValueTable data={user} propertiesToShow={propertiesToShow[3]} />
      </GridedRow>
    </div>
  )
}

export default ViewSupportTicketUser


// WEBPACK FOOTER //
// ./src/components/common/Support/ViewSupportTicketUser.js